import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=6ac1ad18&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Loading.vue"
export default component.exports